/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ItemModeList = {
    readonly url?: string;
    value: string;
    description?: string | null;
    readonly created_by_name?: string;
    list_name?: ItemModeList.list_name;
    readonly created_at?: string;
    code?: string | null;
};

export namespace ItemModeList {

    export enum list_name {
        TICKET_STATUS = 'TICKET_STATUS',
        COVERAGE_TYPE = 'COVERAGE_TYPE',
        GSX_SERVICE_TYPE = 'GSX_SERVICE_TYPE',
        REPAIR_TYPE = 'REPAIR_TYPE',
        GSX_REPAIR_TYPE = 'GSX_REPAIR_TYPE',
        CUSTOMER_TYPE = 'CUSTOMER_TYPE',
        UNIT_PART = 'UNIT_PART',
        STATES = 'STATES',
        COUNTRY = 'COUNTRY',
        SERIALIZABLE_INVENTORY_ITEM = 'SERIALIZABLE_INVENTORY_ITEM',
        LOANER_INVENTORY_PART_NUMBERS = 'LOANER_INVENTORY_PART_NUMBERS',
        LOANER_INVENTORY_PENALTY_REASONS = 'LOANER_INVENTORY_PENALTY_REASONS',
        CONSIGNMENT_TYPE = 'CONSIGNMENT_TYPE',
        REPORT_TYPES = 'REPORT_TYPES',
        UPLOAD_DOCUMENT_TYPES = 'UPLOAD_DOCUMENT_TYPES',
        REPAIR_INVENTORY_ITEMS = 'REPAIR_INVENTORY_ITEMS',
    }


}
